var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.00096 14.00101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 14.00096,
    height: 14.00096,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48751,7.00045l5.425,5.425a.37264.37264,0,0,1,0,.481l-1.006,1.007a.37591.37591,0,0,1-.481,0l-5.425-5.425-5.425,5.425a.325.325,0,0,1-.24.087.325.325,0,0,1-.241-.087l-1.007-1.007a.325.325,0,0,1-.087-.24.33084.33084,0,0,1,.087-.241l5.425-5.425-5.425-5.425a.325.325,0,0,1-.087-.24.32924.32924,0,0,1,.087-.241l1.007-1.006a.325.325,0,0,1,.24-.088.32728.32728,0,0,1,.241.088l5.425,5.425,5.425-5.425a.37264.37264,0,0,1,.481,0l1.006,1.006a.325.325,0,0,1,.088.24.32728.32728,0,0,1-.088.241Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3f740a9afa9ae33a5722eaa644e879f6.svg";
export { ForwardRef as ReactComponent };